import { Component, OnInit, Input } from '@angular/core';
import { InvoiceAdvancedSearch } from '../../shared/invoice/invoice-advanced-search.model';
import { DatePeriodEnum } from '../../../shared/search-expression/date-period.enum';
import { TranslationService } from '../../../shared/translation/translation.service';
import { RevenueItemService } from '../../shared/revenue-items/revenue-item.service';
import { MemberService } from '../../../member/shared/member.service';
import { ListingSubCategoryService } from '../../../listing-catagories/listing-sub-category.service';
import { Office, OfficeSearch, Official, OfficialSearch, VoterVoiceService } from '../../../integrations/voter-voice/shared/index';
import { VerticalNahbService } from '../../../vertical/nahb/shared/vertical-nahb.service';
import { VerticalNaaService } from '../../../vertical/naa/shared/vertical-naa.service';
import { AgingPeriodEnum } from '../../shared/invoice/aging-period.model';

@Component({
  selector: 'wl-invoice-selector-summary',
  templateUrl: 'invoice-selector-summary.component.html',
  providers: [
    TranslationService,
    RevenueItemService,
    MemberService,
    ListingSubCategoryService,
    VoterVoiceService,
    VerticalNaaService,
    VerticalNahbService,
  ],
  standalone: false,
})
export class InvoiceSelectorSummaryComponent implements OnInit {
  @Input() searchParams: InvoiceAdvancedSearch;
  public billingMonth: string;
  public revenueItemDescription: string;
  public hiddenRevenueItemNumCount: number;
  @Input() summaryVisible: boolean;
  public allRevenueItemNumVisible: boolean;
  public paramCount: number;
  public datePeriodEnum: object = DatePeriodEnum;
  public agingPeriodEnum: object = AgingPeriodEnum;
  public revenueItems: Array<string>;

  public constructor(private _revenueItemService: RevenueItemService) {
    this.allRevenueItemNumVisible = false;
    this.paramCount = 0;
    this.revenueItems = new Array<string>();
  }

  ngOnInit() {
    this.refresh();
  }

  public toggleSummaryVisible() {
    this.summaryVisible = !this.summaryVisible;
    if (this.summaryVisible) this.refresh();
  }

  public hideSummary() {
    this.summaryVisible = false;
  }

  public refresh() {
    this.paramCount = 0;
    this.paramCount += this.searchParams.RevenueItemNums.length;
    this.paramCount += this.searchParams.InvoiceInfoSearchExpressions.length;
    if (this.searchParams.AgingPeriod > 0) {
      this.paramCount++;
    }
    this.hiddenRevenueItemNumCount = Math.max(this.searchParams.RevenueItemNums.length - 2, 0);
    this._revenueItemService.getRevenueItems().then((data) => {
      data = data.filter((x) => {
        return this.searchParams.RevenueItemNums.indexOf(x.ItemNum) > -1;
      });
      this.revenueItems = data.map((x) => {
        return x.ItemName;
      });
    });
  }

  public toggleRevenueItemNumSliceEnd() {
    this.allRevenueItemNumVisible = !this.allRevenueItemNumVisible;
  }
}
